import { render, staticRenderFns } from "./ResearchLoadingSpinner.vue?vue&type=template&id=2ef23dc0&scoped=true"
import script from "./ResearchLoadingSpinner.vue?vue&type=script&lang=js"
export * from "./ResearchLoadingSpinner.vue?vue&type=script&lang=js"
import style0 from "./ResearchLoadingSpinner.vue?vue&type=style&index=0&id=2ef23dc0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef23dc0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ef23dc0')) {
      api.createRecord('2ef23dc0', component.options)
    } else {
      api.reload('2ef23dc0', component.options)
    }
    module.hot.accept("./ResearchLoadingSpinner.vue?vue&type=template&id=2ef23dc0&scoped=true", function () {
      api.rerender('2ef23dc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/ResearchLoadingSpinner.vue"
export default component.exports